import { Map } from 'immutable'
import * as actions from './actions'

export const initialState = Map()

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actions.SHOW_TOAST:
      return state.set(`${Date.now()}`, payload)
    case actions.HIDE_TOAST:
      return state.delete(payload.toastId)
    default:
      return state
  }
}
